<template>
	<div class="product-add" v-loading="loading">
		<el-tabs v-model="activeName">
			<el-tab-pane label="基础设置" name="basic"></el-tab-pane>
			<!-- <el-tab-pane label="加钟项目" name="clockProduct"></el-tab-pane> -->
			<el-tab-pane label="项目描述" name="content"></el-tab-pane>
			<el-tab-pane label="禁忌说明" name="spec"></el-tab-pane>
			<el-tab-pane label="下单说明" name="buyset"></el-tab-pane>
		</el-tabs>
		<!--form表单-->
		<el-form size="small" ref="form" :model="form" label-width="180px" v-if="!loading">
			<!--基础信息-->
			<Basic v-show="activeName == 'basic'"></Basic>
			<!--禁忌说明-->
			<Spec v-show="activeName == 'spec'"></Spec>
			<!--项目描述-->
			<Content v-show="activeName == 'content'"></Content>
			<!--下单说明-->
			<Buyset v-show="activeName == 'buyset'"></Buyset>
			<clockProduct v-show="activeName == 'clockProduct'"></clockProduct>
			<!--审核-->
			<div class="common-button-wrapper"
				:style="old_audit == 0 || old_audit == 20 ? 'height: 100px;' : 'height: 50px'">
				<Audit v-if="old_audit == 0 || old_audit == 20"></Audit>
				<el-button size="small" type="info" @click="cancelFunc">取消</el-button>
				<el-button size="small" type="primary" @click="onSubmit('edit')" :disabled="save_loading">发布</el-button>
				<!-- <el-button size="small" type="primary" @click="onSubmit('audit')" :disabled="save_loading">审核</el-button> -->
				<!-- <el-button size="small" type="primary" @click="onSubmit('edit')" :disabled="save_loading" v-if="old_audit==10">发布
        </el-button>
        <el-button size="small" type="primary" @click="onSubmit('audit')" :disabled="save_loading" v-else>审核</el-button> -->
			</div>
		</el-form>
	</div>
</template>

<script>
	import PorductApi from "@/api/product.js";
	import Basic from "./part/Basic.vue";
	import Spec from "./part/Spec.vue";
	import Content from "./part/Content.vue";
	import Buyset from "./part/Buyset.vue";
	import Audit from "./part/Audit.vue";
	import {
		formatModel
	} from "@/utils/base.js";
	import clockProduct from "./part/clockProduct.vue";
	export default {
		components: {
			/*基础信息*/
			Basic,
			/*规格信息*/
			Spec,
			/*商品详情*/
			Content,
			/*高级设置*/
			Buyset,
			/*审核*/
			Audit,
			clockProduct
		},
		data() {
			return {
				activeName: "basic",
				/* 审核状态*/
				/*商品ID*/
				productId: 0,
				/*判断是编辑*/
				scene: "edit",
				/*是否正在加载*/
				loading: true,
				/*是否正在提交保存*/
				save_loading: false,
				/*form表单数据*/
				form: {
					model: {},
					/*商品分类*/
					category: [],
					serviceList: [],
					supplierList: [],
					/*运费模板*/
					delivery: [],
					/*会员等级*/
					gradeList: [],
					/*规格数据*/
					specData: null,
					/*是否锁住*/
					isSpecLocked: false,
					/*分销基础设置*/
					basicSetting: {},
					/*分销佣金设置*/
					agentSetting: {}
				},
				/*模型数据*/
				model: {
					serviceCategory: null,
					isClock: 0,
					/*商品名称*/
					productName: "",
					/*商品分类*/
					categoryId: null,
					serviceId: null,
					shopSupplierId: 0,
					/*商品图片*/
					image: [],
					detailimg: [],
					product_clock: [],
					clockProduct: [],
					isPicture: 0,
					contentImage: [],
					video_id: 0,
					poster_id: 0,
					/*商品卖点*/
					sellingPoint: "",
					/*规格类别,默认10单规格，20多规格*/
					specType: 10,
					/*库存计算方式,默认20付款减库存，10下单减库存*/
					deductStockType: 20,
					/*检查用户等级*/
					isAloneGrade: 0,
					/*单规格*/
					sku: {
						/*产品价格*/
						productPrice: 0,
						/*产品划线价*/
						linePrice: 0,
						/*库存数量*/
						stockNum: 0,
						/*商品重量*/
						product_weight: 0,
						/*商品编码*/
						productNo: ""
					},
					/*多规格类别*/
					spec_many: {
						/*多规格类别*/
						spec_attr: [],
						/*多规格表格数据*/
						spec_list: []
					},
					/*商品详情内容*/
					content: "",
					tabooContent: "",
					orderContent: "",
					/*运费模板ID*/
					deliveryId: "",
					/*商品状态*/
					productStatus: 10,
					/*初始销量*/
					salesInitial: 0,
					/*商品排序，默认100*/
					productSort: 100,
					/*是否开启积分赠送,默认1为开启，0为关闭*/
					isPointsGift: 1,
					/*是否允许使用积分抵扣,默认1为允许，0为不允许*/
					isPointsDiscount: 1,
					/*最大积分抵扣数量*/
					maxPointsDiscount: 0,
					/*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
					isEnableGrade: 1,
					/*等级金额类型,默认10为百分比，20为固定金额*/
					aloneGradeType: 10,
					/*限购会员*/
					gradeIds: [],
					/*商品分销是否开启*/
					is_agent: 0,
					/*是否开启单独分销,默认0为关闭，1为开启*/
					isIndAgent: 0,
					/*分销佣金类型,默认10为百分比，20为固定金额*/
					agentMoneyType: 10,
					/*一级佣金*/
					firstMoney: null,
					/*二级佣金*/
					secondMoney: null,
					/*三级佣金*/
					thirdMoney: null,
					/*是否虚拟商品*/
					isVirtual: 0,
					/*限购数量*/
					limitNum: 0,
					audit_status: "",
					audit_remark: "",
					/*虚拟商品发货方式*/
					virtualAuto: 0,
					/*虚拟商品发货内容*/
					virtualContent: "",
					// 简介
					intro: ''
				}
			};
		},
		provide: function() {
			return {
				form: this.form
			};
		},
		created() {
			/*获取列表*/
			this.productId = this.$route.query.productId;
			this.scene = this.$route.query.scene;
			this.getData();
		},
		methods: {
			/**
			 * 获取基础数据
			 */
			getData: function() {
				let self = this;
				PorductApi.getEditData({
							productId: self.productId,
							scene: self.scene
						},
						true
					)
					.then(res => {
						self.loading = false;
						self.old_audit = res.data.model.audit_status;

						/*单独产品折扣*/
						if (
							res.data.model.aloneGradeEquity != null &&
							typeof res.data.model.aloneGradeEquity != "undefined"
						) {
							let equitys = res.data.model.aloneGradeEquity;
							res.data.gradeList.forEach(item => {
								item.product_equity = equitys[item.grade_id];
							});
						}

						Object.assign(self.form, res.data);

						if (res.data.specData) {
							self.$set(self.form.model, "spec_many", res.data.specData);
						} else {
							self.$set(self.form.model, "spec_many", {
								spec_attr: [],
								spec_list: []
							});
							self.form.model.sku = res.data.model.sku[0];
						}
						if (
							self.form.model.audit_status != 10 &&
							self.form.model.audit_status != 20
						) {
							self.form.model.audit_status = 10;
						}
						self.form.model.productStatus = res.data.model.productStatus.value;
						// 等级id转换成数组
						for (let i = 0; i < self.form.model.gradeIds.length; i++) {
							self.form.model.gradeIds[i] = parseInt(
								self.form.model.gradeIds[i]
							);
						}
						if (self.form.model.deliveryId == 0) {
							self.$set(self.form.model, "is_delivery_free", 0);
						} else {
							self.$set(self.form.model, "is_delivery_free", 1);
						}
					})
					.catch(error => {
						self.loading = false;
					});
			},

			/*转JSON字符串*/
			convertJson(list) {
				let obj = {};
				list.forEach(item => {
					obj[item.grade_id] = item.product_equity;
				});
				return JSON.stringify(obj);
			},

			/*提交*/
			onSubmit: function(submit_type) {
				let self = this;
				// console.log(submit_type)
				// console.log(self.model, self.form.model)
				self.$refs.form.validate(valid => {
					let params = formatModel(self.model, self.form.model);
					if (valid) {
						let params = formatModel(self.model, self.form.model);
						params.scene = self.scene;
						params.image = self.ImgKeepId(params.image);
						params.product_id = self.product_id;
						params.aloneGradeEquity = self.convertJson(self.form.gradeList);
						params.submit_type = submit_type;
						params.serviceTime = self.form.model.serviceTime;
						params.tag = "";
						// if (self.form.model.tag != null && self.form.model.tag.length) {
						// 	params.tag = self.form.model.tag.join(",");
						// }
						// console.log(params);

						self.save_loading = true;
						PorductApi.editProduct(
						  {
						    productId: self.productId,
						    params: JSON.stringify(params)
						  },
						  true
						)
						  .then(data => {
						    self.save_loading = false;
						    self.$message({
						      message: "保存成功",
						      type: "success"
						    });
						    self.cancelFunc();
						  })
						  .catch(error => {
						    self.save_loading = false;
						  });
					} else {
						self.$message({
							message: "请检查必填项是否填写完整",
							type: "error"
						});
					}
				});
			},

			/*图片数值只保留id*/
			ImgKeepId(list) {
				let arr = [];
				for (let i = 0, length = list.length; i < length; i++) {
					let obj = {
						imageId: list[i].imageId,
						fileId: list[i].fileId
					};
					arr.push(obj);
				}
				return arr;
			},

			/*保存为草稿*/
			Draft() {
				let self = this;
				self.form.model.productStatus = 30;
				self.onSubmit();
			},

			/*取消*/
			cancelFunc() {
				this.$router.back(-1);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.basic-setting-content {}

	.product-add {
		padding-bottom: 50px;
	}

	.mb50 {
		margin-bottom: 50px;
	}
</style>


// WEBPACK FOOTER //
// src/views/product/product/edit.vue